import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectActiveTab } from "slices/settings/selectors";

const SettingsSideBar = () => {
  const activeTab = useSelector(selectActiveTab);
  const { navBarAndSideBarDisabled } = useSelector((state) => state.app);

  return (
    <ul className="settings_sidebar">
      <li className={`settings_sidebar-link ${activeTab === 1 && "active"}`}>
        <Link to="/">Readability Thresholds</Link>
      </li>
      <li className={`settings_sidebar-link ${activeTab === 2 && "active"}`}>
        <Link to="/readability">Readability Ignore List</Link>
      </li>
      <li className={`settings_sidebar-link ${activeTab === 3 && "active"}`}>
        <Link to="/discovery">Discovery Ignore List</Link>
      </li>
      <li className={`settings_sidebar-link ${activeTab === 4 && "active"}`}>
        <Link to="/acronym">Acronym Ignore List</Link>
      </li>
      <li className={`settings_sidebar-link ${activeTab === 5 && "active"}`}>
        <Link to="/excel_output">Excel Output Customization</Link>
      </li>
      {navBarAndSideBarDisabled && (
        <div
          className="settings_sidebar__disable_mask"
          data-testid="disable-mask"
        />
      )}
    </ul>
  );
};

export default SettingsSideBar;
